import { ServerUserRoles } from '@api/v4/private/resources/users';
import { ServerResourceType } from '@components/bulk_management/user-settings/resource-sidebar';
import { FormikErrors, FormikTouched } from 'formik';

export type FormTabs = 'invite' | 'message';

export interface FormResource {
  type: ServerResourceType;
  key: string;
}

export interface InvitationFormValues {
  resources: FormResource[];
  emails: string[];
  permissionLevel: ServerUserRoles;
  personalMessage: string;
  preventEmail: boolean;
}

export interface MessageFormValues {
  resources: FormResource[];
  recipients: ServerUserRoles[];
  personalMessage: string;
}

export const currentTabValuesIsInvite = (
  tab: FormTabs,
  values: InvitationFormValues | MessageFormValues
): values is InvitationFormValues => (
  tab === 'invite'
);

export const currentTabErrorsIsInvite = (
  tab: FormTabs,
  errors: FormikErrors<InvitationFormValues | MessageFormValues>
): errors is FormikErrors<InvitationFormValues> => (
  tab === 'invite'
);

export const currentTabTouchedIsInvite = (
  tab: FormTabs,
  touched: FormikTouched<InvitationFormValues | MessageFormValues>
): touched is FormikTouched<InvitationFormValues> => (
  tab === 'invite'
);

export const currentTabValuesIsMessage = (
  tab: FormTabs,
  values: InvitationFormValues | MessageFormValues
): values is MessageFormValues => (
  tab === 'message'
);

export const currentTabErrorsIsMessage = (
  tab: FormTabs,
  errors: FormikErrors<InvitationFormValues | MessageFormValues>
): errors is FormikErrors<MessageFormValues> => (
  tab === 'message'
);

export const currentTabTouchedIsMessage = (
  tab: FormTabs,
  touched: FormikTouched<InvitationFormValues | MessageFormValues>
): touched is FormikTouched<MessageFormValues> => (
  tab === 'message'
);